import { Utils } from 'mbc/dist/mbc-core';
import labels from './labels';

const Colors = Utils.colors.mds_chart_color;
const EmptyXDomain = (() => {
  const year = new Date().getFullYear();
  return [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map(i => year - i);
})();

export default {
  settings: {
    languageId: 'en-US',
    currencyId: 'USD',
    showReturnCategory: false,
    showMonthTag: true,
    keyMapping: {
      id: 'name',
      date: 'timePeriod',
      value: 'value',
    },
    emptyChartSetting: {
      id: 'mbc-vertical-bar-chart empty',
      legend: false,
      y1AxisOrient: 'right',
      y1TicksAlign: 'left',
      y1TickSymbol: '%',
      y1TickWidth: 139,
      ticksNumber: 2,
      showGrayBands: true,
      xDomain: EmptyXDomain,
      yDomain: [-20, 20],
      tooltip: false,
      tooltipNullValueDisplay: '&mdash;',
    },
    barChartSetting: {
      legend: false,
      y1AxisOrient: 'right',
      y1TicksAlign: 'left',
      y1TickSymbol: '%',
      y1TickWidth: 139,
      ticksNumber: 2,
      showGrayBands: true,
      barGroupFixedPadding: 0,
      barPadding: 0,
      barOuterPadding: 0,
      colors: Object.keys(Colors).map(i => Colors[i]),
      tooltipNullValueDisplay: '&mdash;',
    },
  },
  format: {
    number: {
      dataType: 'number',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  components: {},
  labels: {
    en: labels['en-US'],
    ...labels,
  },
};
